import React from 'react';
import { Box } from '@mui/material';
import { QuestionCard } from '../QuestionCard';
import { QuestionLabel } from '../QuestionLabel';
import { ToggleOption } from '../ToggleOption';
import { DaysVisualization } from '../DaysVisualization';
import { DIGEST_FREQUENCY_OPTIONS } from '../../constants/onboardingOptions';
import { DigestFrequency } from '../../types/onboarding';

interface DigestFrequencyQuestionProps {
  value: DigestFrequency | null;
  onChange: (value: DigestFrequency) => void;
}

export const DigestFrequencyQuestion: React.FC<DigestFrequencyQuestionProps> = ({ value, onChange }) => {
  return (
    <QuestionCard>
      <QuestionLabel>How often would you like to receive a digest?</QuestionLabel>

      {/* Wrapper to ensure both rows have same width */}
      <Box sx={{ maxWidth: 'fit-content' }}>
        {/* Frequency Buttons */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '16px',
            width: '100%',
          }}
        >
          {DIGEST_FREQUENCY_OPTIONS.map((option) => (
            <ToggleOption
              key={option.value}
              value={option.value}
              label={option.label}
              isSelected={value === option.value}
              onClick={() => onChange(option.value)}
              disabled={option.disabled}
              tooltipText={option.tooltipText}
            />
          ))}
        </Box>

        {/* Days of Week Visualization */}
        <DaysVisualization frequency={value} />
      </Box>
    </QuestionCard>
  );
};
